import { indexWrapCss } from "../../Main/css/Main.style";
import Header from "../header/Header";
import React, { useState } from "react";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import ScrollToTop from "../../controls/ScrollToTop";
import usePageTitle from "../../../hooks/usePageTitle";

const Privacy = () => {
    usePageTitle("개인정보 처리 방침");

    const [search, setSearch] = useState<any>([]);
    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };

    const navigate = useNavigate();


    return (
        <>

            <div css={indexWrapCss}>
                <Header
                    onChange={onSearchHandler}
                    searchValue={search}
                    name="search"
                    activeFlag=""
                />

                <div
                    className="max-w-[1200px] w-full min-w-0 mx-auto flex flex-col gap-20 py-[120px] px-6 text-black">
                    <span className={"text-2xl font-bold"}>개인정보처리방침</span>


                    <div className={"text-base"}>


                        <p> 북밋(이하 "회사")은 개인정보 보호법에 따라 이용자의 개인정보를 보호하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같은 개인정보 처리방침을
                            수립·공개합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p>제1조 (개인정보의 수집 항목 및 수집 방법)</p>
                        <p> 회사는 회원가입, 서비스 이용 과정에서 다음과 같은 개인정보를 수집합니다.</p>
                        <p> 1. 수집 항목:</p>
                        <p>· 일반 항목: 이메일, 비밀번호, 닉네임, 서비스 이용 기록(IP 포함), 팔로우/좋아요 활동 내역</p>
                        <p>· 본인확인 시: 이름, 생년월일, 성별, 휴대전화번호, CI(연계정보), DI(중복가입확인정보)</p>
                        <p> 2. 수집 방법: </p>
                        <p>· 회원가입 시 직접 입력</p>
                        <p>· 서비스 이용 중 자동 수집(쿠키, 로그 등)</p>
                        <p>· 본인확인 시 외부 인증기관을 통한 자동 수집</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제2조 (개인정보의 수집 및 이용 목적)</p>
                        <p> 수집한 개인정보는 다음 목적을 위해 활용됩니다.</p>
                        <p> 1. 회원관리: 회원가입 의사 확인, 이용자 식별, 서비스 이용 이력 관리</p>
                        <p> 2. 서비스 제공: 콘텐츠 추천, 좋아요 및 팔로우 기반 맞춤형 기능 제공</p>
                        <p> 3. 보안 및 운영: 부정 이용 방지, 고객 민원 응대, 법령 준수</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p>제3조 (개인정보의 보유 및 이용기간)</p>
                        <p>1. 회사는 서비스 운영 목적 달성 시까지 개인정보를 보유·이용하며, 이용자가 개인정보 삭제를 요청한
                            경우에는 지체
                            없이
                            해당
                            정보를
                            파기합니다.</p>
                        <p>2. 단, 법령에 따라 일정 기간 보존이 필요한 경우 해당 기간 동안 보관합니다:</p>
                        <p className={"pl-4"}>o 전자상거래 등에서의 소비자 보호에 관한 법률에 따른 표시·광고에 관한 기록: 6개월</p>
                        <p className={"pl-4"}>o 서비스 이용 관련 기록(IP 포함): 3개월 (통신비밀보호법)</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p>제4조 (개인정보의 제3자 제공)</p>
                        <p>회사는 이용자의 개인정보를 외부에 제공하지 않으며, 법령에 따라 예외적으로 제공되는 경우를 제외하고는
                            제3자에게
                            제공하지
                            않습니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제5조 (개인정보 처리의 위탁)</p>
                        <p>회사는 안정적인 서비스 제공을 위해 일부 업무를 외부에 위탁할 수 있으며, 위탁 시 계약을 통해 개인정보
                            보호
                            의무를
                            부여합니다.
                            현재
                            위탁하는
                            업체는
                            없습니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제6조 (이용자 및 법정대리인의 권리와 행사 방법)</p>
                        <p> 이용자는 언제든지 본인의 개인정보에 대해 열람·수정·삭제 요청을 할 수 있으며, 서비스 내 고객센터 또는
                            이메일을
                            통해
                            요청할 수
                            있습니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제7조 (개인정보의 파기절차 및 방법)</p>
                        <p> 회사는 개인정보 보유기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당
                            정보를
                            파기합니다.</p>
                        <p className={"pl-4"}> • 전자적 파일: 복구 불가능한 방법으로 영구 삭제</p>
                        <p className={"pl-4"}> • 출력물: 분쇄 또는 소각</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제8조 (쿠키의 사용)</p>
                        <p> 회사는 개인 맞춤형 서비스를 제공하기 위해 쿠키를 사용할 수 있습니다. 이용자는 브라우저 설정을 통해 쿠키
                            저장을
                            거부하거나
                            삭제할 수
                            있습니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제9조 (개인정보 보호 책임자)</p>
                        <p> • 개인정보 보호책임자: [운영자명]</p>
                        <p> • 이메일: [with.bookmeet@gmail.com]</p>
                        <p className={"pl-4"}> ※ 변경 시 서비스 내 공지를 통해 고지합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제10조 (정책 변경 및 고지 의무)</p>
                        <p> 본 방침은 시행일로부터 적용되며, 변경이 있을 경우 서비스 내 공지를 통해 사전 고지합니다.</p>

                        <p> 최초 시행일: 2025년 5월 14일</p>


                    </div>


                    <div className="flex w-full justify-center">
                        <button
                            onClick={() => navigate("/")}
                            className="border-2 border-main bg-white px-8 md:px-[100px] py-[14px] rounded-full font-namsan text-lg text-main font-bold max-w-full"
                        >
                            홈으로 돌아가기
                        </button>
                    </div>


                </div>


            </div>


            <Footer />

        </>
    )
}

export default Privacy;
